/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateClassResponse
 */
export interface CreateClassResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateClassResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof CreateClassResponse
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClassResponse
     */
    entityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClassResponse
     */
    displayName?: string | null;
}

/**
 * Check if a given object implements the CreateClassResponse interface.
 */
export function instanceOfCreateClassResponse(value: object): value is CreateClassResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateClassResponseFromJSON(json: any): CreateClassResponse {
    return CreateClassResponseFromJSONTyped(json, false);
}

export function CreateClassResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClassResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
    };
}

export function CreateClassResponseToJSON(json: any): CreateClassResponse {
    return CreateClassResponseToJSONTyped(json, false);
}

export function CreateClassResponseToJSONTyped(value?: CreateClassResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
        'entityId': value['entityId'],
        'displayName': value['displayName'],
    };
}

